// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import ViewCompanyAnswers from "../../components/DueDiligence/ViewAnswers/ViewCompanyAnswers";
import { RiskScoreDto } from "../../types/DueDiligenceTypes";

const ViewCompanyAnswersEntry: React.FC<{ customerId: string; riskscoreId: string; riskscore: RiskScoreDto, answerListId: number, active: boolean, activeDescription: string | null }> = ({
    customerId,
    riskscoreId,
    riskscore,
    answerListId,
    active,
    activeDescription
}) => {
    return (
        <Entrypoint>
            <ViewCompanyAnswers
                customerId={customerId}
                riskscoreId={riskscoreId}
                riskscore={riskscore}
                answerListId={answerListId}
                active={active}
                activeDescription={activeDescription}
            />
        </Entrypoint>
    )
};

export default ViewCompanyAnswersEntry;